import { render } from "./WorkloadRecommending.vue?vue&type=template&id=c25d6c44"
import script from "./WorkloadRecommending.vue?vue&type=script&lang=js"
export * from "./WorkloadRecommending.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__